import React from 'react'
import { Stack, List, ListItem, Link } from '@chakra-ui/react'

export const Pagination = ( { totalResults, resultsPerPage, nextPage } ) => {
  const pageNumbers = []
  for ( let i = 1; i <= Math.ceil( totalResults / resultsPerPage ); i++ ) {
    pageNumbers.push( i )
  }
  return (
    <Stack isInline w="100%">
      <List m="0 auto" display="inline-flex">
        {pageNumbers.map( number => (
          <ListItem key={number}>
            <Link as="button" px={1} mt={0.5}
              href="#" onClick={() => nextPage( number )}
              _focusWithin={{ bg: "brand.mainYellow", color: "black" }}
              _hover={{ bg: "brand.mainYellow", color: "black" }}
              _active={{ bg: "brand.mainYellow", color: "black" }}
            >
              {number}
            </Link>
          </ListItem>
        ) )}
      </List>
    </Stack>
  )
}